import styled from "styled-components";

export const Container = styled.div`
  &.alert-msg {
    /* min-height: 260px; */
    display: flex;
    align-items: center;
    .modal-body {
      display: flex;
      align-items: center;
      flex-direction: column;
      .modal-title {
        font-size: 22px;
        line-height: 30px;
        font-family: "latobold";
        margin-bottom: 7px;
      }
      .ModalContentMsg {
        p {
          font-size: 20px;
          line-height: 25px;
          margin-top: 10px;
          text-align: center;
          padding: 0 10px;
        }
      }
      .AlertBtn {
        background: linear-gradient(180deg, #61b01f 0, #27911b) !important;
        border-radius: 4px;
        width: 130px;
        height: 37px;
        font-size: 14px;
        line-height: 19px;
        color: #ffffff;
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  > Modal {
    > div {
      max-height: calc(80vh - 152px);
      overflow: auto;
      color: $primary-text;
      font-size: 1.125rem;
      text-align: center;
      border: none !important;

      > div {
        padding: 10px !important;
        h3 {
          padding: 24px 24px 0 24px;
          margin: 0;
          color: #0a223a;
          font-weight: bold;
          text-align: center;
          font-size: 28px;
        }
        button {
          background: transparent;
          margin-left: auto;
        }
      }
      p {
        text-align: center !important;
        margin: 0px !important;
      }
    }
  }
  .modal-footer {
    border: none;
  }
  .filter-cancel-button {
    background: #b0b7bb;
    border-radius: 4px;
    width: 130px;
    height: 37px;
    font-size: 14px;
    line-height: 19px;
    color: #ffffff;
    border: none;
    margin-right: 6px;
  }

  @media screen and (min-width: 1024px) {
    Modal {
      margin: auto;
    }
  }
`;

export const AlertButton = styled.div`
  margin-bottom: 60px;
  .AlertBtn {
    width: 115px;
    height: 37px;
  }
`;
export const SelectWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  .chart-date-picker{
    height: 37px;
    width: 170px;
    .MuiInputBase-root{
      height: 37px !important;
    }
  }
  > div {
    display: flex;
    /* p {
      margin: 12px;
    } */
  }
  select,
  label {
    padding: 5px;
    margin: 2px 0 0;
    font-size: 18px;
  }
  @media (max-width: 650px) {
    > div {
      flex-direction: column;
    }
  }
`;
